(function () {
  'use strict';
  if (window.DeckauraTrafficQuality) return;

  var startedAt = Date.now();
  var meaningful = false;
  var trustedMeaningful = false;
  var engagementCohort = 'low_intent';
  var published = {};
  var tags = {};
  var INTERNAL_KEY = 'deckaura_internal_qa_v1';
  var SESSION_CONTINUITY_KEY = 'deckaura_tq_session_v1';
  var LOCAL_CONTINUITY_KEY = 'deckaura_tq_seen_v1';
  var ACQUISITION_KEY = 'deckaura_tq_first_touch_v1';

  function token(value, max) {
    return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9_-]/g, '_').slice(0, max || 48);
  }
  function queryInternal() {
    return /(?:[?&](?:deckaura_internal|codex_audit|alltools_audit)=)/i.test(location.search)
      || /(?:^|\.)localhost$/i.test(location.hostname);
  }
  function internalQa() {
    try {
      if (queryInternal()) sessionStorage.setItem(INTERNAL_KEY, '1');
      return queryInternal() || sessionStorage.getItem(INTERNAL_KEY) === '1';
    } catch (_) { return queryInternal(); }
  }
  function captureContinuity() {
    var sessionSeen = false;
    var localSeen = false;
    // These values are fixed booleans, not visitor IDs or timestamps. They only
    // distinguish a first browser/session view from a continued visit.
    try {
      sessionSeen = sessionStorage.getItem(SESSION_CONTINUITY_KEY) === '1';
      sessionStorage.setItem(SESSION_CONTINUITY_KEY, '1');
    } catch (_) {}
    try {
      localSeen = localStorage.getItem(LOCAL_CONTINUITY_KEY) === '1';
      localStorage.setItem(LOCAL_CONTINUITY_KEY, '1');
    } catch (_) {}
    return Object.freeze({
      session: sessionSeen,
      local: localSeen,
      missing: !sessionSeen && !localSeen
    });
  }
  function referrerHost() {
    try { return document.referrer ? new URL(document.referrer).hostname.toLowerCase() : ''; } catch (_) { return ''; }
  }
  function currentAcquisitionCohort() {
    var params = new URLSearchParams(location.search);
    var medium = token(params.get('utm_medium'), 24);
    if (params.has('gclid') || params.has('fbclid') || /^(?:cpc|ppc|paid|paid_social|display)$/.test(medium)) return 'paid';
    var host = referrerHost();
    if (/(^|\.)google\.[a-z.]+$/.test(host)) return 'organic_google';
    if (!host) return 'direct';
    return 'referral';
  }
  function captureAcquisition() {
    var current = currentAcquisitionCohort();
    try {
      var stored = token(sessionStorage.getItem(ACQUISITION_KEY), 24);
      if (/^(?:paid|organic_google|direct|referral)$/.test(stored)) return stored;
      sessionStorage.setItem(ACQUISITION_KEY, current);
    } catch (_) {}
    return current;
  }
  function country() {
    var locale = window.DeckauraLocale || {};
    var shopify = window.Shopify || {};
    return String(locale.country || shopify.country || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 2);
  }
  function device() {
    return window.matchMedia && window.matchMedia('(max-width: 720px)').matches ? 'mobile' : 'desktop';
  }
  function armClarityQueue() {
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
  }
  function setTag(key, value) {
    var safeKey = token(key, 48);
    var safeValue = token(value, 80);
    if (!safeKey) return;
    tags[safeKey] = safeValue;
    try { if (typeof window.clarity === 'function') window.clarity('set', safeKey, safeValue); } catch (_) {}
  }
  function replayTags() {
    Object.keys(tags).forEach(function (key) {
      try { if (typeof window.clarity === 'function') window.clarity('set', key, tags[key]); } catch (_) {}
    });
  }
  function scheduleTagReplay() {
    [1000, 3500, 8000, 16000, 30000, 60000].forEach(function (delay) {
      window.setTimeout(replayTags, delay);
    });
    window.addEventListener('load', replayTags, { once: true });
    window.addEventListener('pageshow', replayTags);
    document.addEventListener('visitorConsentCollected', replayTags);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') replayTags();
    });
  }

  var continuity = captureContinuity();
  var firstTouchAcquisition = captureAcquisition();

  function acquisitionCohort() {
    return internalQa() ? 'internal_qa' : firstTouchAcquisition;
  }

  function independentSignalGroups() {
    var acquisitionProfile = acquisitionCohort() === 'direct' && device() === 'desktop' && country() === 'SG';
    var noTrustedInteraction = !trustedMeaningful && document.visibilityState === 'visible';
    return {
      // direct + desktop + SG is one combined acquisition-profile group.
      acquisition_profile: acquisitionProfile,
      continuity_missing: continuity.missing,
      no_trusted_interaction: noTrustedInteraction
    };
  }
  function signalCount(groups) {
    return Object.keys(groups).reduce(function (count, key) {
      return count + (groups[key] ? 1 : 0);
    }, 0);
  }
  function applyTags(status, count) {
    setTag('traffic_cohort', acquisitionCohort());
    setTag('engagement_cohort', engagementCohort);
    setTag('internal_qa', internalQa() ? 'true' : 'false');
    setTag('traffic_quality', status);
    setTag('traffic_signal_count', String(Math.max(0, Number(count) || 0)));
    // Retain the existing tag name for dashboard compatibility. The value now
    // counts independent groups, not individual attributes within a profile.
    setTag('automation_signal_count', String(Math.max(0, Number(count) || 0)));
  }
  function publish(status, count) {
    var key = status + ':' + engagementCohort + ':' + count;
    if (published[key]) return;
    published[key] = true;
    var payload = {
      traffic_cohort: acquisitionCohort(),
      engagement_cohort: engagementCohort,
      traffic_quality: status,
      internal_qa: internalQa(),
      device: device(),
      automation_signal_count: Math.max(0, Number(count) || 0),
      elapsed_ms: Math.max(0, Date.now() - startedAt)
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('traffic_quality_classified', payload);
      }
    } catch (_) {}
    try { document.dispatchEvent(new CustomEvent('deckaura:traffic-quality', { detail: payload })); } catch (_) {}
  }
  function classify() {
    if (internalQa()) {
      applyTags('internal_qa', 0);
      publish('internal_qa', 0);
      return;
    }
    var groups = independentSignalGroups();
    var count = signalCount(groups);
    // A client-only cohort is intentionally conservative: the combined
    // acquisition profile must be present alongside another independent group.
    // This labels for reporting only and never blocks or changes page behavior.
    var suspected = groups.acquisition_profile && count >= 2 && !trustedMeaningful;
    var status = suspected ? 'suspected_automation' : (trustedMeaningful ? 'likely_human' : 'unqualified');
    applyTags(status, count);
    publish(status, count);
  }
  function markMeaningful(reason, highIntent, trusted) {
    meaningful = true;
    if (trusted) trustedMeaningful = true;
    if (highIntent) engagementCohort = 'high_intent';
    else if (engagementCohort === 'low_intent') engagementCohort = 'qualified';
    var status = internalQa() ? 'internal_qa' : (trustedMeaningful ? 'likely_human' : 'unqualified');
    applyTags(status, 0);
    if (reason) setTag('engagement_reason', token(reason, 48));
    publish(status, 0);
  }
  function trustedInteraction(event) {
    if (!event || event.isTrusted !== true) return;
    ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (name) {
      document.removeEventListener(name, trustedInteraction, true);
    });
    markMeaningful(event.type || 'interaction', false, true);
  }

  armClarityQueue();
  applyTags(internalQa() ? 'internal_qa' : 'unclassified', 0);
  scheduleTagReplay();

  ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (name) {
    document.addEventListener(name, trustedInteraction, { capture: true, passive: true });
  });
  ['deckaura:tarot-funnel-event', 'deckaura:funnel-event'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var detail = event && event.detail || {};
      var eventName = String(detail.name || 'funnel_event');
      // Page views, price checks and automatically rendered results are useful
      // funnel stages, but are not evidence that a human interacted. Only a
      // user-action stage may raise intent, and it still needs a trusted browser
      // interaction before traffic_quality becomes likely_human.
      if (!/^(?:paid_cta_click|package_selected|draw_(?:started|succeeded)|question_submitted|checkout_(?:prepare_start|intent_created|cart_ready|redirect_attempt|redirect_success))$/.test(eventName)) return;
      markMeaningful(eventName, true, false);
    });
  });

  window.setTimeout(classify, 40000);

  window.DeckauraTrafficQuality = Object.freeze({
    markMeaningful: function (reason, highIntent) { markMeaningful(reason, highIntent, false); },
    cohort: acquisitionCohort,
    isInternal: internalQa
  });
})();
